import { Box, Typography, Button, LinearProgress, useTheme } from '@mui/material'
import { useInsumo } from '../../../../shared/context/insumoContext'
import { CloudUpload as CloudUploadIcon, Download as DownloadIcon } from '@mui/icons-material'
import DropFiles from '../../../../shared/components/DropFiles'
import { useEffect } from 'react'
export default function ListMasiveComponent() {
    const theme = useTheme()
    const { loadMasiveInsumos, loadingUploadMasive, dataMasive, responseMasive, processMasiveInsumos, loadingMasive, setDataMasive, setResponseMasive } = useInsumo()

    useEffect(() => {
        return () => {
            setDataMasive(null)
            setResponseMasive(null)
        };
    }, []);

    return (
        <Box sx={{ padding: '20px' }}>
        <DropFiles onChange={(files) => loadMasiveInsumos(files)} />

        <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                marginTop: 2,
                marginBottom: 3,
                padding: 2,
                backgroundColor: theme.palette.background.paper,
                borderRadius: 1,
                boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
                        ¿Primera vez cargando insumos?
                    </Typography>
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                        Descarga la plantilla Excel para cargar tus insumos masivamente
                    </Typography>
                </Box>
                <Button
                    variant="outlined"
                    href="https://operacionessistema.s3.us-west-2.amazonaws.com/plantillas/RESOURCES.xlsx"
                    target="_blank"
                    endIcon={<DownloadIcon />}
                    sx={{
                        minWidth: '140px',
                        '&:hover': {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText
                        }
                    }}
                >
                    Descargar Plantilla
                </Button>
            </Box>

        <Box sx={{ marginTop: '20px' }} >
            <Button disabled={!dataMasive || loadingMasive} variant="contained" color="primary" onClick={processMasiveInsumos} startIcon={<CloudUploadIcon />}
            >
                {loadingUploadMasive ? 'Cargando...' : 'Procesar y cargar (' + (dataMasive?.length || 0) + ' insumos)'}
            </Button>
        </Box>

        {loadingMasive && (
            <Box sx={{ marginTop: '20px' }}>
                <LinearProgress />
            </Box>
        )}

        {responseMasive && (
            <>
            <Box sx={{ marginTop: '20px' }}>
                <Typography variant="h6">Resultados de la carga</Typography>


                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
                        <Box sx={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: theme.palette.success.light,
                            minWidth: '200px'
                        }}>
                            <Typography variant="subtitle1">Insumos creados</Typography>
                            <Typography variant="h4">{responseMasive.insumos_created.length}</Typography>
                        </Box>

                        <Box sx={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: theme.palette.error.light,
                            minWidth: '200px'
                        }}>
                            <Typography variant="subtitle1">Insumos no creados</Typography>
                            <Typography variant="h4">{responseMasive.insumos_not_create.length}</Typography>
                        </Box>

            

            </Box>

            </Box>
           


            {responseMasive.insumos_not_create.length > 0 && (
                <Box sx={{ marginTop: '20px' }}>
                    <Typography variant="h6">Insumos no creados</Typography>
                    <Box sx={{
                    maxHeight: '200px',
                    overflowY: 'auto',
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: '4px'
                }}>
                    {responseMasive.insumos_not_create.map((item, index) => (
                        <Box key={index} sx={{
                            padding: '10px',
                            borderBottom: index < responseMasive.insumos_not_create.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
                            backgroundColor: index % 2 === 0 ? theme.palette.action.hover : 'transparent'
                        }}>
                            <Typography variant="body2" fontWeight="bold">
                                {item.insumo.name || 'Sin nombre'}
                            </Typography>
                            <Typography variant="body2" color="error">
                                Error: {typeof item.message === 'object' ? item.message.message || JSON.stringify(item.message) : item.message || 'Sin mensaje'}
                            </Typography>
                        </Box>
                    ))}
                </Box>
                </Box>
            )}

            </>

        )}



    </Box>
    )
}